import Stack from '@mui/material/Stack';
import { useEffect } from 'react';
import CustomerSuspended from '../../../components/customerSuspended/CustomerSuspended';
import useAuthStore from '../../../datastore/useAuth';
import useSelectedSite from '../../../hooks/useSelectedSite';
import CustomerNavbar from '../components/CustomerNavbar';

export default function CustomerLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { startPolling, stopPolling } = useSelectedSite((state) => ({
    startPolling: state.startPolling,
    stopPolling: state.stopPolling,
  }));

  const { currentUser, isSuspended } = useAuthStore()
  const isCustomerSuspended = currentUser && isSuspended

  useEffect(() => {
    startPolling();
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  return (
    <Stack sx={{ flex: 1, height: '100vh' }}>
      <CustomerNavbar />
      <Stack
        sx={{
          flexGrow: 1,
        }}
      >
        {
          isCustomerSuspended ? (
            <CustomerSuspended />
          ) : children
        }
      </Stack>
    </Stack>
  );
}
